import { getScoreColor, getTier } from '../utils/scoring';

export default function ScoreGauge({ score, size = 180, label = 'Next Index' }) {
  const tier = getTier(score);
  const color = getScoreColor(score);
  const radius = (size - 20) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 10) * circumference;
  const center = size / 2;

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="transform -rotate-90">
          {/* Background ring */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke="rgba(51, 78, 104, 0.4)"
            strokeWidth="8"
            fill="none"
          />
          {/* Score ring */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke={tier.color}
            strokeWidth="8"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            className="transition-all duration-1000 ease-out"
          />
          {/* Glow effect */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke={tier.color}
            strokeWidth="12"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            opacity="0.15"
            className="transition-all duration-1000 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-4xl font-black" style={{ color: tier.color }}>
            {score.toFixed(1)}
          </span>
          <span className="text-xs text-navy-400 font-medium mt-0.5">{label}</span>
        </div>
      </div>
      <div className="mt-3 text-center">
        <span
          className="inline-block px-3 py-1 rounded-full text-xs font-semibold"
          style={{ backgroundColor: tier.color + '20', color: tier.color }}
        >
          {tier.name}
        </span>
        <p className="text-navy-400 text-xs mt-1">{tier.label}</p>
      </div>
    </div>
  );
}
